<template>
  <div class="tco-workbench">
    <h1>TCO Workbench</h1>
    
    <div class="controls-section">
      <div class="controls-row">
        <div class="product-selection">
          <label for="product-select">Select Product:</label>
          <select id="product-select" v-model="selectedProduct" class="product-dropdown">
            <option value="" disabled>-- Select a Product --</option>
            <option v-for="product in products" :key="product.id" :value="product.id">
              {{ product.name }}
            </option>
          </select>
        </div>
      
        <div class="action-buttons">
          <button class="action-button calculate" @click="calculate">
            <span class="icon">📊</span>
            Calculate
          </button>
          <button class="action-button add-quotes" @click="addQuotes">
            <span class="icon green-icon large-plus">+</span>
            Add Quotes
          </button>
          <button class="action-button export" @click="exportToCsv">
            <span class="icon">📥</span>
            Extract to CSV
          </button>
        </div>
      </div>
    </div>
    
    <transition name="fade-slide">
      <div class="comparison-table-container" v-if="showTable" :key="tableKey">
      <table class="comparison-table">
        <thead class="header-row">
          <tr>
            <th class="animate-col col-0">Details</th>
            <th class="source-column animate-col col-1">Source 1</th>
            <th class="source-column animate-col col-2">Source 2</th>
            <th class="source-column animate-col col-3">Source 3</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableRows" :key="index" :class="{ 'transit-border': row.detail === 'Transit Mode' }">
            <td class="detail-cell animate-col col-0">{{ row.detail }}</td>
            <td class="animate-col col-1">{{ row.source1 }}</td>
            <td class="animate-col col-2">{{ row.source2 }}</td>
            <td class="animate-col col-3">{{ row.source3 }}</td>
          </tr>
          <tr class="total-row">
            <td class="detail-cell animate-col col-0">Total Cost of Ownership</td>
            <td class="animate-col col-1">{{ calculateTotal('source1') }}</td>
            <td class="animate-col col-2">{{ calculateTotal('source2') }}</td>
            <td class="animate-col col-3">{{ calculateTotal('source3') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TcoWorkbench',
  created() {
    // Reset the workbench when first created
    this.resetWorkbench();
  },
  
  // Watch for route changes
  watch: {
    '$route'(to) {
      // If navigating to the home/workbench route, reset the component
      if (to.path === '/') {
        this.resetWorkbench();
      }
    }
  },
  data() {
    return {
      selectedProduct: '',
      showTable: false,
      tableKey: 0,
      products: [
        { id: 1, name: 'Product A' },
        { id: 2, name: 'Product B' },
        { id: 3, name: 'Product C' },
        { id: 4, name: 'Product D' }
      ],
      tableRows: [
        { detail: 'Source / Supplier', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Incoterm', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Purchase Quantity', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Destination Facility', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Transit Mode', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Acquisition Cost', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Freight Cost', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Duty, Tarriffs, Taxes', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Inventory Holding Cost', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Maintenance / Management Cost', source1: '$10.00', source2: '$11.00', source3: '$12.00' },
        { detail: 'Decomission Cost', source1: '$10.00', source2: '$11.00', source3: '$12.00' }
      ]
    }
  },
  methods: {
    calculate() {
      if (!this.selectedProduct) {
        alert('Please select a product first');
        return;
      }
      
      // Force re-render by incrementing the key
      this.tableKey++;
      
      // If table is not shown yet, show it
      if (!this.showTable) {
        this.showTable = true;
      }
    },
    addQuotes() {
      alert('Add Quotes functionality will be implemented here');
    },
    exportToCsv() {
      alert('Export to CSV functionality will be implemented here');
    },
    calculateTotal(sourceKey) {
      // In a real application, this would calculate the sum dynamically
      if (sourceKey === 'source2') {
        return '$11.00';
      } else if (sourceKey === 'source3') {
        return '$12.00';
      } else {
        return '$10.00';
      }
    },
    resetWorkbench() {
      // Reset product selection
      this.selectedProduct = '';
      // Hide the table
      this.showTable = false;
    }
  }
}
</script>

<style scoped>
.tco-workbench {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  color: #243666;
  margin-bottom: 30px;
  text-align: center;
}

.controls-section {
  margin-bottom: 30px;
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.controls-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.product-selection {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 300px;
  flex: 1;
}

label {
  font-weight: bold;
  min-width: 120px;
}

.product-dropdown {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border: 1px solid #50b490;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  color: #243666;
  cursor: pointer;
  transition: transform 0.2s;
  min-width: 180px;
  background: linear-gradient(to bottom, #d7ffe6 0%, #bcffdb 50%, #a5f0c5 100%);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
  position: relative;
}

.action-button::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 60%);
  border-radius: 4px;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.action-button:active {
  transform: translateY(1px);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.7);
  background: linear-gradient(to bottom, #a5f0c5 0%, #bcffdb 50%, #d7ffe6 100%);
}

.icon {
  font-size: 20px;
}

.green-icon {
  color: #50b490;
}

.large-plus {
  font-size: 28px;
  font-weight: bold;
  line-height: 20px;
}

.comparison-table-container {
  overflow-x: auto;
  margin-top: 30px;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
}

.comparison-table th,
.comparison-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}

.header-row tr {
  border-bottom: 2px solid #50b490;
}

/* .header-row th {
  border-top: 2px solid #50b490;
  border-bottom: 2px solid #50b490;
}

.header-row th:first-child {
  border-left: 2px solid #50b490;
}

.header-row th:last-child {
  border-right: 2px solid #50b490;
} */

.transit-border td {
  border-bottom: 2px solid #50b490;
}

.total-row {
  font-weight: bold;
}

.total-row td {
  border-top: 2px solid #50b490;
  background-color: #f9f9f9;
}

.comparison-table th {
  background-color: #bcffdb;
  font-weight: bold;
}

.comparison-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.comparison-table tr:hover {
  background-color: #f1f1f1;
}

.detail-cell {
  font-weight: bold;
  width: 1%;
  white-space: nowrap;
}

.source-column {
  width: 1%;
  min-width: 100px;
  white-space: nowrap;
}

/* Table animation styles */
.fade-slide-enter-active {
  transition: all 0.5s ease;
}

.fade-slide-leave-active {
  transition: none;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
}

/* Column animation styles */
.animate-col {
  transition-property: transform, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter-active .animate-col {
  transition-duration: 0.5s;
}

.fade-slide-enter-from .animate-col {
  transform: translateY(-20px);
  opacity: 0;
}

/* Staggered timing for columns */
.fade-slide-enter-active .col-0 {
  transition-delay: 0s;
}

.fade-slide-enter-active .col-1 {
  transition-delay: 0.1s;
}

.fade-slide-enter-active .col-2 {
  transition-delay: 0.2s;
}

.fade-slide-enter-active .col-3 {
  transition-delay: 0.3s;
}

@media (max-width: 992px) {
  .controls-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .product-selection {
    margin-bottom: 15px;
  }
  
  .action-buttons {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
  }
  
  .action-button {
    width: 100%;
  }
}
</style>
